import styled from 'styled-components'
import { BLUE_PRINCIPAL, GREEN, GREY_DARK, GREY_LIGHTS, GREY_MEDIUM, WHITE } from '../../utils/colors'

export const Container = styled.div`
`

export const PatientListInfo = styled.div`
  cursor: pointer;
  font-size: 18px;
  line-height: 20px;
  color: ${BLUE_PRINCIPAL};
  font-weight: 700;
  span {
    margin-top: 5px;
    display: block;
    font-size: 14px;
    font-weight: normal;
    color: ${GREY_MEDIUM};
  }
`

export const ListContainer = styled.div`
  margin: -30px;
  margin-bottom: 126px;
  margin-top: 0px;
`
export const PatientInfoViewer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 2fr;
  gap: 0px 1px;
  background-color: #E7E7E7;
  border-top: 1px solid  #E7E7E7;
  border-bottom: 1px solid  #E7E7E7;
`

export const PatientInfo = styled.div`
  padding: 14px 30px 18px;
  background-color: ${WHITE};
  color: ${GREY_DARK};

  span {
    display: block;
    font-size: 16px;
    line-height: 26px;
    color: ${GREY_LIGHTS};
    margin-bottom: 5px;
  }
`

export const Patient = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    margin-right: 30px;
    margin-left: 30px;
  }

  .edit {
    color: ${GREEN};
    font-size: 12px;
    line-height: 18px;
  }

  h3 {
    flex: 1;
  }
`

export const ContainerExam = styled.div`
  overflow: auto;
  max-height: 787px;
`

export const GraphContainer = styled.div`
  padding: 0px 10px 10px;
  h4 {
    font-size: 12px;
    line-height: 26px;
  }
`
